import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { initializeSentry } from './config/sentry';

import { getLanguage } from './utils/language';
import './fonts/Madras/MadrasBlack.woff2';
import './fonts/Madras/MadrasRegular.woff2';
import LCEvent from './utils/customEvents';
import FirebaseService from './config/firebase';
import { isFirebaseAllowed, isSentryAllowed } from './config/didomi';
import featureFlag from './config/featureFlag';
import configs from './config';

// replace console.* for disable log on production
console.log('Current Environment:', configs.envConfig.currentEnv.name);
if (configs.envConfig.currentEnv.isProduction) {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
}

// // Save the original console.log function to a variable
// const originalConsoleLog = console.log;

// // Redefine console.log with support for an undefined number of arguments
// console.log = function (...args) {
//     // Convert objects to strings using JSON.stringify
//     const formattedArgs = args.map((arg) => (typeof arg === 'object' ? JSON.stringify(arg) : arg));

//     // Join the formatted arguments into a single string with a space between each argument
//     const message = formattedArgs.join(' ');

//     // Output the message to the console using the original console.log function
//     originalConsoleLog(message);
// };

//= ===================================//
//= ============== RGPD ===============//
//= ===================================//
if (featureFlag.didomi.active) {
    let isSentryInitialized = false;
    let isFirebaseInitialized = false;

    const handleRgpdReady = (event: any) => {
        console.log('======> LCEvent.RGPD_READY <========');
        const didomi = event?.detail?.didomi;
        const hasSentryConsent = isSentryAllowed(didomi);
        const hasFirebaseConsent = isFirebaseAllowed(didomi);

        // Consent for sentry changed
        if (hasSentryConsent) {
            console.log('Sentry is approved', hasSentryConsent);

            // Sentry init
            initializeSentry();
            isSentryInitialized = true;
        } else if (isSentryInitialized) {
            console.log('Sentry is not approved but started need a reload');
            window.location.reload(); // Remove Sentry completely
            return;
        }

        if (hasFirebaseConsent) {
            console.log('Firebase is approved', hasFirebaseConsent);

            // Firebase init
            FirebaseService.initializeFirebase();
            isFirebaseInitialized = true;
        } else if (isFirebaseInitialized) {
            console.log('Firebase not approved but started need a reload');
            window.location.reload(); // Remove Sentry completely
        }
    };

    window.addEventListener(LCEvent.RGPD_READY, handleRgpdReady);

    // Cleanup lors de la fermeture de la page
    window.onbeforeunload = () => {
        window.removeEventListener(LCEvent.RGPD_READY, handleRgpdReady);
    };
} else {
    console.log('Didomi feature desactivated launching Sentry and Firebase');

    // Sentry init
    initializeSentry();

    // Firebase init
    FirebaseService.initializeFirebase();
}

const root = createRoot(document.getElementById('root') as HTMLElement);
document.documentElement.lang = getLanguage();
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorker.unregister();
